import { useEffect } from "react";

const SITE = "Alyssa Retza";

/** Sets the browser tab title for the current page. */
export function usePageTitle(title?: string) {
  useEffect(() => {
    document.title = title ? `${title} — ${SITE}` : `${SITE} — Digital Strategy & Web Product`;
  }, [title]);
}
